export enum IntegrationsQueryKeys {
  ListResources = 'integrations/listResources',
}
